import React from 'react';
import { navLinks, site } from '../data/site';
const socials = [{
  name: 'Facebook',
  href: 'https://facebook.com',
  path: 'M13.5 21v-7.2h2.4l.36-2.8H13.5V9.2c0-.81.22-1.36 1.38-1.36h1.47V5.33A19.6 19.6 0 0 0 14.2 5.2c-2.13 0-3.6 1.3-3.6 3.7v2.1H8.2v2.8h2.4V21h2.9z'
}, {
  name: 'Instagram',
  href: 'https://instagram.com',
  path: 'M12 7.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2zm0 7.6a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm5.9-7.8a1.07 1.07 0 1 1-2.14 0 1.07 1.07 0 0 1 2.14 0zM12 4.6c-2.4 0-2.7.01-3.65.05-.94.05-1.58.2-2.14.42-.58.23-1.07.53-1.56 1.02-.49.49-.79.98-1.02 1.56-.22.56-.37 1.2-.42 2.14C3.17 10.74 3.16 11.04 3.16 12s.01 1.26.05 2.21c.05.94.2 1.58.42 2.14.23.58.53 1.07 1.02 1.56.49.49.98.79 1.56 1.02.56.22 1.2.37 2.14.42.95.04 1.25.05 3.65.05s2.7-.01 3.65-.05c.94-.05 1.58-.2 2.14-.42.58-.23 1.07-.53 1.56-1.02.49-.49.79-.98 1.02-1.56.22-.56.37-1.2.42-2.14.04-.95.05-1.25.05-2.21s-.01-1.26-.05-2.21c-.05-.94-.2-1.58-.42-2.14a4.3 4.3 0 0 0-1.02-1.56 4.3 4.3 0 0 0-1.56-1.02c-.56-.22-1.2-.37-2.14-.42C14.7 4.61 14.4 4.6 12 4.6zm0 1.62c2.36 0 2.64.01 3.57.05.86.04 1.33.18 1.64.3.41.16.71.35 1.02.66.31.31.5.61.66 1.02.12.31.26.78.3 1.64.04.93.05 1.21.05 3.57s-.01 2.64-.05 3.57c-.04.86-.18 1.33-.3 1.64-.16.41-.35.71-.66 1.02-.31.31-.61.5-1.02.66-.31.12-.78.26-1.64.3-.93.04-1.21.05-3.57.05s-2.64-.01-3.57-.05c-.86-.04-1.33-.18-1.64-.3a2.7 2.7 0 0 1-1.02-.66 2.7 2.7 0 0 1-.66-1.02c-.12-.31-.26-.78-.3-1.64-.04-.93-.05-1.21-.05-3.57s.01-2.64.05-3.57c.04-.86.18-1.33.3-1.64.16-.41.35-.71.66-1.02.31-.31.61-.5 1.02-.66.31-.12.78-.26 1.64-.3.93-.04 1.21-.05 3.57-.05z'
}, {
  name: 'WhatsApp',
  href: 'https://wa.me/50255551234',
  path: 'M12.04 3.5c-4.7 0-8.5 3.8-8.5 8.5 0 1.5.4 2.96 1.15 4.24L3.5 20.5l4.4-1.15a8.47 8.47 0 0 0 4.14 1.06c4.7 0 8.5-3.8 8.5-8.5s-3.8-8.41-8.5-8.41zm4.9 12.06c-.2.56-1.15 1.09-1.6 1.13-.44.05-.85.2-2.86-.58-2.4-.94-3.94-3.36-4.06-3.52-.12-.16-.98-1.3-.98-2.48 0-1.18.62-1.75.84-1.99.22-.24.48-.3.64-.3h.46c.15 0 .35-.06.54.41.2.48.68 1.66.74 1.78.06.12.1.26.02.42-.08.16-.12.26-.24.4l-.36.42c-.12.12-.24.25-.1.49.12.24.58.94 1.22 1.52.82.74 1.5.97 1.74 1.09.24.12.38.1.52-.06.14-.16.6-.7.76-.94.16-.24.32-.2.54-.12.22.08 1.4.66 1.64.78.24.12.4.18.46.28.06.1.06.58-.14 1.14z'
}, {
  name: 'TikTok',
  href: 'https://tiktok.com',
  path: 'M16.6 5.82a4.28 4.28 0 0 1-1.02-2.82h-2.9v11.2a2.2 2.2 0 1 1-1.57-2.11V9.13a5.1 5.1 0 1 0 4.47 5.06V8.9a7.1 7.1 0 0 0 4.02 1.25V7.25a4.24 4.24 0 0 1-3-1.43z'
}];
export function Footer() {
  return <footer className="bg-forest-900 pb-8 pt-16 text-white/70" data-id="element-139" data-mp="1hje64vb5rbrx">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-140" data-mp="1mj8vgufabtav">
        <div className="grid gap-12 border-b border-white/12 pb-12 lg:grid-cols-[1.4fr_1fr_1fr]" data-id="element-141" data-mp="1mhpbotuf704c">
          <div data-id="element-142" data-mp="1rgsiaiq1teef">
            <p className="font-display text-xl tracking-[0.22em] text-gold-400" data-id="element-143" data-mp="3ob53hu28ul0w">{site.empresa}</p>
            <p className="mt-4 max-w-xs text-[14px] leading-relaxed" data-id="element-144" data-mp="3odhrooylhrme">{site.slogan}</p>
            <div className="mt-7 flex gap-3" data-id="element-145" data-mp="3tcce00vrtyb9">
              {socials.map(social => <a key={social.name} href={social.href} target="_blank" rel="noreferrer" aria-label={social.name} className="grid h-10 w-10 place-items-center rounded-full border border-white/20 transition-colors duration-150 ease-smooth hover:border-gold-400 hover:text-gold-400" data-id="element-146" data-mp="2agew5owk49a7">
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true" data-id="element-147" data-mp="2tbvh4e1fa8uj">
                    <path d={social.path} data-id="element-148" data-mp="2pajrw9mgnpmv" />
                  </svg>
                </a>)}
            </div>
          </div>

          <nav aria-label="Enlaces rápidos" data-id="element-149" data-mp="2fezwdobt6syn">
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-white" data-id="element-150" data-mp="2fdymhn6j4cii">
              Enlaces rápidos
            </p>
            <ul className="mt-5 space-y-3 text-[14px]" data-id="element-151" data-mp="13zb7usiwplvq">
              {navLinks.map(link => <li key={link.href} data-id="element-152" data-mp="2rvzkn7zbpvr2">
                  <a href={link.href} className="transition-colors duration-150 ease-smooth hover:text-gold-400" data-id="element-153" data-mp="2ruxzubsi9uw5">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-154" data-mp="2nuxjumprdbmz">
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-white" data-id="element-155" data-mp="2nue1j4w74l8f">
              {site.proyecto}
            </p>
            <address className="mt-5 space-y-3 text-[14px] not-italic leading-relaxed" data-id="element-156" data-mp="3fl214ci81ijz">
              <p data-id="element-157" data-mp="31lj5ukaie1p3">{site.direccion}</p>
              <p data-id="element-158" data-mp="31mc6d3ivjuys">
                <a href="tel:+50255551234" className="hover:text-gold-400" data-id="element-159" data-mp="31krbfcsnea0e">
                  {site.telefono}
                </a>
              </p>
              <p data-id="element-160" data-mp="1q6dpwelda6nj">
                <a href={`mailto:${site.email}`} className="hover:text-gold-400" data-id="element-161" data-mp="1q5uhppliqwmp">
                  {site.email}
                </a>
              </p>
            </address>
          </div>
        </div>

        <p className="pt-6 text-[12px] text-white/45" data-id="element-162" data-mp="1nlfy5i9edmr9">
          © 2026 {site.empresa}. Todos los derechos reservados. Proyecto {site.proyecto},{' '}
          {site.ubicacion}.
        </p>
      </div>
    </footer>;
}